/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { FormWithFieldConfigsProvider } from '../context/index';
import RenderForm from '../components/render-form/index';
import { defaultGroupFields } from '../util';

const FormConfigs = ({
  fields,
  initialValues,
  className,
  disabled = false,
  layout = 'vertical',
  renderMiddlewares = [],
  middlewares = [],
  groupFields = defaultGroupFields,
  FIELD_PROVIDER,
}) => {
  return (
    <FormWithFieldConfigsProvider
      layout={layout}
      fields={fields}
      initialValues={initialValues}
      renderMiddlewares={renderMiddlewares}
      middlewares={middlewares}
      groupFields={groupFields}
      FIELD_PROVIDER={FIELD_PROVIDER}
      disabled={disabled}>
      <RenderForm className={className} />
    </FormWithFieldConfigsProvider>
  );
};

FormConfigs.propTypes = {
  fields: PropTypes.array.isRequired,
  initialValues: PropTypes.object.isRequired,
  renderMiddlewares: PropTypes.array,
  middlewares: PropTypes.array,
  FIELD_PROVIDER: PropTypes.elementType.isRequired,
  layout: PropTypes.oneOf(['vertical', 'horizontal']),
  groupFields: PropTypes.func,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default FormConfigs;
